import { Routes } from '@angular/router';
import { adminGuard } from './guards/auth/admin.guard';
import { authGuard } from './guards/auth/auth.guard';
import { dockPermissionGuard } from './guards/auth/dock-permission.guard';
import { LoginLandingComponent } from './pages/login-landing/login-landing';
import { LoginPageComponent } from './pages/login/login.component';
import { UserProfileComponent } from './pages/user-profile/user-profile.component';
export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginPageComponent },
  { path: 'login/callback', component: LoginLandingComponent },
  {
    path: 'profile',
    component: UserProfileComponent,
    canActivate: [authGuard],
    data: {
      hideFromNavigation: true,
    },
  },
  {
    path: 'downloads',
    loadComponent: () =>
      import('./pages/downloads/downloads.component').then(
        (m) => m.DownloadsComponent,
      ),
    canActivate: [authGuard],
    data: { hideFromNavigation: true },
  },
  {
    path: 'dashboard',
    loadComponent: () =>
      import('./pages/dashboard/dashboard.component').then(
        (m) => m.DashboardComponent,
      ),
    canActivate: [authGuard],
  },
  {
    path: 'access-denied',
    loadComponent: () =>
      import('./pages/access-denied/access-denied.component').then(
        (m) => m.AccessDeniedComponent,
      ),
  },
  {
    path: 'dcc-configuration',
    loadComponent: () =>
      import('./pages/dcc-configuration/dcc-configuration.component').then(
        (m) => m.DccConfigurationPageComponent,
      ),
    canActivate: [authGuard, adminGuard],
    data: { featureLabel: 'DCC Configuration' },
  },
  {
    path: 'user-role',
    loadComponent: () =>
      import('./pages/user-role/user-role.component').then(
        (m) => m.UserRolePageComponent,
      ),
    canActivate: [authGuard, adminGuard],
    data: { featureLabel: 'User Management' },
  },
  {
    path: 'dock-menu/:dccCode',
    loadComponent: () =>
      import('./pages/dock-menu/dock-menu.component').then(
        (m) => m.DockMenuComponent,
      ),
    canActivate: [authGuard],
    children: [
      {
        path: 'dock-receiving',
        loadComponent: () =>
          import('./pages/dock-receiving/dock-receiving.component').then(
            (m) => m.DockReceivingPageComponent,
          ),
        canActivate: [authGuard, dockPermissionGuard('manage', 'package')],
        data: {
          featureLabel: 'Dock Receiving',
          featureFlag: 'Receive Packages',
        },
      },
      {
        path: 'device-control-center',
        loadComponent: () =>
          import('./pages/device-control-center/device-control-center-hub.component').then(
            (m) => m.DeviceControlCenterHubComponent,
          ),
        canActivate: [
          authGuard,
          dockPermissionGuard('manage', 'devicecontrolcenter'),
        ],
        data: {
          featureLabel: 'Device Control Center',
          featureFlag: 'Device Control Center',
        },
      },
      {
        path: 'device-search',
        loadComponent: () =>
          import('./pages/device-control-center/device-search/device-search-details.component').then(
            (m) => m.DeviceSearchDetailsComponent,
          ),
        canActivate: [
          authGuard,
          dockPermissionGuard('manage', 'devicecontrolcenter'),
        ],
        data: {
          featureLabel: 'Device Control Center',
          featureFlag: 'Device Control Center',
        },
      },
      {
        path: 'vip-processing',
        loadComponent: () =>
          import('./pages/device-control-center/vip/vip-processing-search.component').then(
            (m) => m.VipProcessingSearchComponent,
          ),
        canActivate: [
          authGuard,
          dockPermissionGuard('manage', 'devicecontrolcenter'),
          dockPermissionGuard('manage', 'vip'),
        ],
        data: {
          featureLabel: 'Device Control Center',
          featureFlag: 'Device Control Center',
        },
      },
      {
        path: 'vip-processing-details',
        loadComponent: () =>
          import('./pages/device-control-center/vip/vip-processing-details.component').then(
            (m) => m.VipProcessingDetailsComponent,
          ),
        canActivate: [
          authGuard,
          dockPermissionGuard('manage', 'devicecontrolcenter'),
          dockPermissionGuard('manage', 'vip'),
        ],
        data: {
          featureLabel: 'Device Control Center',
          featureFlag: 'Device Control Center',
        },
      },
      {
        path: 'screen-protector-removal',
        loadComponent: () =>
          import('./pages/device-control-center/screen-protector/screen-protector-removal.component').then(
            (m) => m.ScreenProtectorRemovalComponent,
          ),
        canActivate: [
          authGuard,
          dockPermissionGuard('manage', 'devicecontrolcenter'),
          dockPermissionGuard('manage', 'screenprotector'),
        ],
        data: {
          featureLabel: 'Device Control Center',
          featureFlag: 'Device Control Center',
        },
      },
      {
        path: 'screen-protector-details',
        loadComponent: () =>
          import('./pages/device-control-center/screen-protector/screen-protector-details.component').then(
            (m) => m.ScreenProtectorDetailsComponent,
          ),
        canActivate: [
          authGuard,
          dockPermissionGuard('manage', 'devicecontrolcenter'),
          dockPermissionGuard('manage', 'screenprotector'),
        ],
        data: {
          featureLabel: 'Device Control Center',
          featureFlag: 'Device Control Center',
        },
      },
      {
        path: 'user-lock',
        loadComponent: () =>
          import('./pages/device-control-center/user-lock/user-lock.component').then(
            (m) => m.UserLockComponent,
          ),
        canActivate: [
          authGuard,
          dockPermissionGuard('manage', 'devicecontrolcenter'),
          dockPermissionGuard('manage', 'userlock'),
        ],
        data: {
          featureLabel: 'Device Control Center',
          featureFlag: 'Device Control Center',
        },
      },
      {
        path: 'returns-receiving',
        loadComponent: () =>
          import('./pages/returns-receiving/returns-receiving.component').then(
            (m) => m.ReturnsReceivingPageComponent,
          ),
        canActivate: [authGuard, dockPermissionGuard('manage', 'package')],
        data: { featureLabel: 'Returns Receiving' },
      },
      {
        path: 'search-dock',
        loadComponent: () =>
          import('./pages/search-dock/search-dock.component').then(
            (m) => m.SearchDockPageComponent,
          ),
        canActivate: [authGuard, dockPermissionGuard('view', 'package')],
        data: { featureLabel: 'Search', featureFlag: 'Dock Search' },
      },
      {
        path: 'item-receiving',
        loadComponent: () =>
          import('./pages/item-receiving/steps/imei-entry.component').then(
            (m) => m.ImeiEntryStepComponent,
          ),
        canActivate: [authGuard, dockPermissionGuard('manage', 'photocapture')],
        data: {
          featureLabel: 'Device Processing',
          featureFlag: 'Device Photo',
        },
      },
      {
        path: 'item-capture',
        loadComponent: () =>
          import('./pages/item-receiving/steps/photo-capture.component').then(
            (m) => m.PhotoCaptureStepComponent,
          ),
        canActivate: [authGuard],
        data: { featureLabel: 'Device Processing' },
      },
      {
        path: 'item-annotate',
        loadComponent: () =>
          import('./pages/item-receiving/steps/annotation.component').then(
            (m) => m.AnnotationStepComponent,
          ),
        canActivate: [authGuard],
        data: { featureLabel: 'Device Processing' },
      },
      {
        path: 'item-summary',
        loadComponent: () =>
          import('./pages/item-receiving/steps/summary.component').then(
            (m) => m.SummaryStepComponent,
          ),
        canActivate: [authGuard],
        data: { featureLabel: 'Device Processing' },
      },
      {
        path: 'device-photo-search',
        loadComponent: () =>
          import('./pages/device-photo-search/device-photo-search.component').then(
            (m) => m.DevicePhotoSearchComponent,
          ),
        canActivate: [authGuard, dockPermissionGuard('view', 'photocapture')],
        data: {
          featureLabel: 'Device Photo Search',
          featureFlag: 'Device Photo',
        },
      },
      {
        path: 'secondary-clear-processing',
        loadComponent: () =>
          import('./pages/secondary-clear-processing/secondary-clear-processing.component').then(
            (m) => m.SecondaryClearProcessingComponent,
          ),
        canActivate: [
          authGuard,
          dockPermissionGuard('manage', 'secondaryclearing'),
        ],
        data: {
          featureLabel: 'Secondary Clear Processing',
          featureFlag: 'Secondary Clear Processing',
        },
      },
      {
        path: 'secondary-clear-dashboard',
        loadComponent: () =>
          import('./pages/secondary-clear-dashboard/secondary-clear-dashboard.component').then(
            (m) => m.SecondaryClearDashboardComponent,
          ),
        canActivate: [
          authGuard,
          dockPermissionGuard('view', 'secondaryclearing'),
        ],
        data: {
          featureLabel: 'Secondary Clear Dashboard',
          featureFlag: 'Secondary Clear Dashboard',
        },
      },
      {
        path: 'sales-rma-processing',
        loadComponent: () =>
          import('./pages/sales-rma-processing/sales-rma-processing.component').then(
            (m) => m.SalesRmaProcessingComponent,
          ),
        canActivate: [authGuard, dockPermissionGuard('manage', 'rma')],
        data: {
          featureLabel: 'Sales RMA Processing',
          featureFlag: 'Sales RMA Processing',
        },
      },
      {
        path: 'sales-rma-imei-entry',
        loadComponent: () =>
          import('./pages/sales-rma-processing/steps/sales-rma-imei-entry.component').then(
            (m) => m.SalesRmaImeiEntryComponent,
          ),
        canActivate: [authGuard, dockPermissionGuard('manage', 'rma')],
        data: { featureLabel: 'Sales RMA Processing' },
      },
      {
        path: 'sales-rma-process-device',
        loadComponent: () =>
          import('./pages/sales-rma-processing/steps/sales-rma-process-device.component').then(
            (m) => m.SalesRmaProcessDeviceComponent,
          ),
        canActivate: [authGuard, dockPermissionGuard('manage', 'rma')],
        data: { featureLabel: 'Sales RMA Processing' },
      },
      {
        path: 'rma-dashboard',
        loadComponent: () =>
          import('./pages/rma-dashboard/rma-dashboard.component').then(
            (m) => m.RmaDashboardComponent,
          ),
        canActivate: [authGuard, dockPermissionGuard('view', 'rmadashboard')],
        data: { featureLabel: 'RMA Dashboard', featureFlag: 'RMA Dashboard' },
      },
      {
        path: 'asn-dashboard',
        loadComponent: () =>
          import('./pages/asn-dashboard/asn-dashboard.component').then(
            (m) => m.AsnDashboardComponent,
          ),
        canActivate: [authGuard, dockPermissionGuard('view', 'package')],
        data: { featureLabel: 'ASN Dashboard', featureFlag: 'Dock Search' },
      },
      {
        path: 'rma-search',
        loadComponent: () =>
          import('./pages/rma-search/rma-search.component').then(
            (m) => m.RmaSearchPageComponent,
          ),
        canActivate: [authGuard, dockPermissionGuard('view', 'rma')],
        data: { featureLabel: 'Search RMA', featureFlag: 'Search RMA' },
      },
      {
        path: 'access-denied',
        loadComponent: () =>
          import('./pages/access-denied/access-denied.component').then(
            (m) => m.AccessDeniedComponent,
          ),
        canActivate: [authGuard],
      },
      {
        // The identifier (tracking/RMA) is passed via navigation state, not the
        // URL, so it isn't exposed in the address bar.
        path: 'questionnaire',
        loadComponent: () =>
          import('./pages/questionnaire/questionnaire-component').then(
            (m) => m.QuestionnaireComponent,
          ),
        canActivate: [authGuard],
      },
    ],
  },
];
